import { createTheme } from '@mui/material/styles';

// as work continues on style guide this will be defined
const theme = () =>
  createTheme({
    typography: {
      fontFamily: '"EYInterstate", sans-serif', // override default Roboto from Material-UI
    },
    colors: {
      black: '#FF0000',
      white: '#FFFFFF',
      green: '#2DB757',
      blue: '#188CE5',
      red: '#FF4136',
      orange: '#FF6D00',
      purple: '#3D108A',
      yellow1: '#D5C101',
      limeGreen: '#2EB757',
      algaeGreen: '#8CE8AD',
      pastelGreen: '#57E188',
      emerald: '#34C768',
      forestGreen: '#189D3E',
      jewel: '#168736',
      darkJewel: '#13652A',
      teal: '#27ACAA',
      iceCold: '#93F0E6',
      turquoise: '#60E6E1',
      puertoRico: '#42C9C2',
      blueChill: '#109090',
      pacificOcean: '#0D7575',
      sherpaBlue: '#004F4f',
      jordyBlue: '#87D3F2',
      pictonBlue: '#4EBEEB',
      vididBlue: '#188BE5',
      darkPictonBlue: '#35A4EB',
      denim: '#1777CF',
      deepSapphire: '#082C65',
      lilac: '#9C82D4',
      fuchsia: '#724BC3',
      kazoo: '#542EA5',
      arapawa: '#240D75',
      darkArapawa: '#0A095A',
      haiti: '#15173E',
      maroon: '#750E5C',
      viola: '#C981B2',
      mulberry: '#B14891',
      plum: '#922B73',
      loulou: '#5A0A42',
      wineberry: '#42152D',
      jon: '#351C21',
      monaLisa: '#FF9A91',
      bitterSweet: '#FF736A',
      carnation: '#F95D54',
      cinnabar: '#E0362C',
      thunderbird: '#B9251C',
      darkTan: '#7A130D',
      koromiko: '#FFB46A',
      neonCarrot: '#FF9831',
      flamenco: '#FF810A',
      blazeOrange: '#F76900',
      trinidad: '#EB4F00',
      fire: '#BC2F00',
      lemonChiffon: '#FFF59D',
      picasso: '#FFF59D',
      bumblee: '#FFEE58',
      sunflower: '#EBD621',
      eyConfidentGrey: '#2E2E38',
      eyGrey0: '#282831',
      eyGrey1: '#747480',
      eyGrey2: '#C4C4CD',
      eyGrey3: '#EAEAF2',
      eyGrey4: '#F6F6FA',
      eyGrey5: '#F6F5FA',
      eyGrey6: '#C4C4CE',
      eyGrey7: '#FAFAFC',
      eyGrey8: '#747479',
      eyGrey9: '#CACAD1',
      eyGrey10: '#24242E',
      eyGrey11: "#E1E1E6",
      eyYellow: '#FFE600',
      eyInteractiveOverlays: '#1A1A24',
      greyBlue: '#5d5d66',
      disabledGrey1: "#9897A6",
      disabledText1:"#F3F3F5",
      eyInteractiveOverlays: "#1A1A24",
      greyBlue: "#5d5d66",
      lightGrey: "#656579",
      errorIconRed: "#FF4336",
      eyGreen:"#26A04B",
      eyGrey12:"#7F7F91",
      eyGrey13: "#E6E6E9",
      eyGrey14: "#6e6e79",

    },
    components: {
      MuiListItem: {
        styleOverrides: {
          root: {
            '&.MuiButtonBase-root:hover, &.MuiListItem-button:hover': {
              backgroundColor: '#F6F5FA',
            },
          },
        },
      },
    },
  });

export default theme;
